import React from "react";
import { Construction } from "lucide-react";
import { PageHeader, Card, EmptyState } from "./UI";

export default function PlaceholderPage({
  title,
  subtitle,
  phase,
  description,
  breadcrumb
}) {
  return (
    <div className="app-container py-8">
      <PageHeader title={title} subtitle={subtitle} breadcrumb={breadcrumb} />
      <Card>
        <EmptyState
          icon={Construction}
          title={`${phase ? phase + " — " : ""}coming soon`}
          hint={
            description ||
            `This area is part of a future phase of the LuxTender build${phase ? ` (${phase})` : ""}. The structure is reserved — functionality will land here.`
          }
        />
      </Card>
    </div>
  );
}
